import clsx from 'clsx'
import {isAPP, KTIcon, URL, WebSite} from '../../../helpers'
import {useLayout} from '../../core'
import {MutableRefObject, useEffect, useLayoutEffect, useRef} from 'react'
import {ToggleComponent} from '../../../assets/ts/components'
import {BrandLockup} from '../../../../app/theme/BrandLogo'
import {watchSidebarAutoMinimize} from './sidebarAutoMinimize'

type PropsType = {
  sidebarRef: MutableRefObject<HTMLDivElement | null>
}

const SidebarLogo = (props: PropsType) => {
  const {config} = useLayout()
  const toggleRef = useRef<HTMLDivElement>(null)

  const appSidebarDefaultMinimizeDesktopEnabled =
    config?.app?.sidebar?.default?.minimize?.desktop?.enabled
  const appSidebarDefaultCollapseDesktopEnabled =
    config?.app?.sidebar?.default?.collapse?.desktop?.enabled
  const toggleType = appSidebarDefaultCollapseDesktopEnabled
    ? 'collapse'
    : appSidebarDefaultMinimizeDesktopEnabled
    ? 'minimize'
    : ''
  const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
  const appSidebarDefaultMinimizeDefault = config.app?.sidebar?.default?.minimize?.desktop?.default

  useEffect(() => {
    setTimeout(() => {
      const toggleObj = ToggleComponent.getInstance(toggleRef.current!) as ToggleComponent | null

      if (toggleObj === null) {
        return
      }

      // Add a class to prevent sidebar hover effect after toggle click
      toggleObj.on('kt.toggle.change', function () {
        // Set animation state
        props.sidebarRef.current!.classList.add('animating')

        // Wait till animation finishes
        setTimeout(function () {
          // Remove animation state
          props.sidebarRef.current!.classList.remove('animating')
        }, 300)
      })
    }, 600)
  }, [toggleRef, props.sidebarRef])

  // Before the first paint, so a 1024px window never shows the sidebar open for a moment.
  useLayoutEffect(() => {
    if (!appSidebarDefaultMinimizeDesktopEnabled) {
      return undefined
    }
    return watchSidebarAutoMinimize(toggleRef.current)
  }, [appSidebarDefaultMinimizeDesktopEnabled])

  return (
    <div className='app-sidebar-logo px-6' id='kt_app_sidebar_logo'>
      {/* The sidebar is light in every layout type (as in the site's panel preview), so the mark is
          always the colour one; the name hides when the sidebar is minimized. */}
      <BrandLockup href={(isAPP ? URL : WebSite) || '/'} nameClassName='app-sidebar-logo-default' />

      {(appSidebarDefaultMinimizeDesktopEnabled || appSidebarDefaultCollapseDesktopEnabled) && (
        <div
          ref={toggleRef}
          id='kt_app_sidebar_toggle'
          className={clsx(
            'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate',
            {active: appSidebarDefaultMinimizeDefault}
          )}
          data-kt-toggle='true'
          data-kt-toggle-state={toggleState}
          data-kt-toggle-target='body'
          data-kt-toggle-name={`app-sidebar-${toggleType}`}
        >
          <KTIcon iconName='double-right' className='fs-2 rotate-180' />
        </div>
      )}
    </div>
  )
}

export {SidebarLogo}
